<template>
  <v-layout row>
    <v-flex xs12 sm10 offset-sm1>
      <v-toolbar flat color="white">
        <v-tooltip bottom>
          <v-btn icon light @click="$router.go(-1)" slot="activator">
            <v-icon color="grey darken-2">arrow_back</v-icon>
          </v-btn>
          <span>{{ $vuetify.t('$vuetify.app.back') }}</span>
        </v-tooltip>
        <v-toolbar-title
          >{{ $vuetify.t('$vuetify.calls.inbox') }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-layout row wrap mt-3 mb-3>
        <v-flex xs12 sm10 offset-sm1 text-xs-center>
          <v-card v-if="result.length > 0">
            <v-list two-line>
              <template v-for="(item, index) in result">
                <v-subheader v-if="item.header" :key="index">
                  {{ item.header }}
                </v-subheader>

                <v-divider
                  v-else-if="item.divider"
                  :inset="item.inset"
                  :key="index"
                ></v-divider>

                <v-list-tile
                  v-else
                  :key="index"
                  avatar
                  @click="messageClicked(item)"
                  v-bind:class="{ 'red lighten-3': !item.isRead }"
                  :to="{ name: 'message', params: { id: item.id } }"
                >
                  <v-list-tile-avatar color="indigo">
                    <span class="white--text headline">{{
                      item.title.charAt(0)
                    }}</span>
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title v-html="item.title"></v-list-tile-title>
                    <v-list-tile-sub-title
                      v-html="item.subtitle"
                    ></v-list-tile-sub-title>
                    <v-list-tile-sub-title v-if="item.read_at"
                      >Read at: {{ item.read_at }}</v-list-tile-sub-title
                    >
                  </v-list-tile-content>
                </v-list-tile>
              </template>
            </v-list>
          </v-card>
          <span v-else>{{ $vuetify.t('$vuetify.calls.inboxIsEmpty') }}</span>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'Inbox',
  mixins: [],
  components: {},
  data() {
    return {
      result: []
    }
  },

  mounted() {
    this.readInbox({ latest: true })
      .then(r => {
        this.groupedMessages()
        return r
      })
      .then(r => {
        this.batchMarkAsDelivered({
          items: r,
          delivered_at: moment().format('YYYY-MM-DD HH:mm:ss')
        }) /* .then(r => {
          // Update in offline DB??
          // But here must be a list of promises and make it for each of them
        })*/
        return r
      })
  },
  computed: {
    ...mapState({
      messages: state => state.messaging.inbox
    })
  },
  methods: {
    ...mapActions({
      readInbox: 'messaging/readInbox',
      batchMarkAsDelivered: 'messaging/batchMarkAsDelivered',
      markAsRead: 'messaging/markAsRead'
    }),
    groupedMessages() {
      const result = []
      let headerDate = null
      console.log('Group messages at inbox by dates')
      _.each(this.messages, (item, index) => {
        // Check date changes and add header
        const curHeaderDate = item.recipient.data.sent_at
          ? moment(item.recipient.data.sent_at).fromNow()
          : 'Newest messages'
        // console.log('headerDate', headerDate, curHeaderDate)
        if (headerDate !== curHeaderDate) {
          headerDate = curHeaderDate
          const headerItem = this.getHeaderItem(curHeaderDate)
          result.push(headerItem)
        }
        result.push(this.getMessageItem(item))
        result.push(this.getDividerItem())
      })
      this.result = result
      return result
    },
    // Header item (with date)
    getHeaderItem(date) {
      return {
        header: date
      }
    },
    // Divider
    getDividerItem() {
      return { divider: true, inset: true }
    },

    // Get message item
    getMessageItem(item) {
      return {
        id: item.id,
        original: item,
        avatar: item.sender.data.avatar ? item.sender.data.avatar.url : null,
        title: item.subject,
        isRead: item.recipient.data.read_at !== null,
        read_at: item.recipient.data.read_at,
        delivered_at: item.recipient.data.delivered_at,
        sent_at: item.recipient.data.sent_at,
        subtitle:
          "<span class='text--primary'>" +
          item.sender.data.full_name +
          '</span> &mdash; ' +
          item.message
      }
    },

    // Click on message in list
    messageClicked(item) {
      console.log('MESSAGE CLICKED', item)
      this.markAsRead({
        item: item.original,
        read_at: moment().format('YYYY-MM-DD HH:mm:ss')
      })
        .then(r => {
          this.groupedMessages()
          return r
        })
        .then(r => {
          // Update in offline DB??
        })
    }
  },
  watch: {
    messages: function() {
      console.log('MESSAGES WATCHER')
      this.groupedMessages()
    }
  }
}
</script>
